import React from "react";
import { cn } from "@/lib/utils";

const LOGOS = {
  xero: { src: "/brand/xero.svg", alt: "Xero" },
  freshbooks: { src: "/brand/freshbooks.png", alt: "FreshBooks" },
  zoho: { src: "/brand/zoho.svg", alt: "Zoho Books" },
  sage: { src: "/brand/sage.svg", alt: "Sage Accounting" },
};

export const ProviderLogo = ({ provider, className }) => {
  const l = LOGOS[provider];
  if (!l) return null;
  return <img src={l.src} alt={l.alt} className={cn("h-4 w-4 shrink-0 rounded-sm object-contain", className)} data-testid={`${provider}-logo`} />;
};
